import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import SelectTemplates from './select-template';
import {
  processPartnersForSendingRates,
} from '../../contractingUtils';
import SendToPartners from '../../generic-components/send-to-partners/container-send-to-partners';
import ReviewSend from './review-send';
import { Step, Stepper, StepLabel, FlatButton, Paper } from 'material-ui';
import RaisedButton from '../../../tc-ui/raised-button-with-loader';
import AddAlloments from './add-allotments';
import pluralize from 'pluralize';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
// Basic Account Partners Threshold
const basicNo = 20;
const propTypes = {
  companyType: PropTypes.string,
  showAllPartners: PropTypes.bool,
  sendingContracts: PropTypes.bool,
  bccSelf: PropTypes.bool,
  assignTag: PropTypes.bool,
  assignFolder: PropTypes.bool,
  tags: PropTypes.array,
  folders: PropTypes.array,
  templateSelected: PropTypes.object,
  templateGroupSelected: PropTypes.object,
  router: PropTypes.object,
  stepIndex: PropTypes.number,
  contractsSent: PropTypes.bool,
  locationId: PropTypes.string,
  partners: PropTypes.array,
  message: PropTypes.string,
  subject: PropTypes.string,
  error: PropTypes.string,
  updateProps: PropTypes.func,
  getTemplates: PropTypes.func,
  getLocations: PropTypes.func,
  clearStore: PropTypes.func,
  sendContracts: PropTypes.func,
  showAllocationError: PropTypes.bool,
  contractingPartners: PropTypes.array,
  newPartnersSelected: PropTypes.array,
  billingPlan: PropTypes.string,
};
class SendContractStepper extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  getStepContent = (validPartners) => {
    const {
      templateSelected,
      stepIndex,
      message,
      showAllPartners,
      subject,
      bccSelf,
      assignTag,
      assignFolder,
      partners,
      contractsSent,
      sendingContracts,
      templateGroupSelected,
      showAllocationError,
    } = this.props;
    const { startDate, endDate } = isNilOrEmpty(templateSelected) ? templateGroupSelected : templateSelected;
    // const contractExistsPartnerExist = R.call(R.compose(R.complement(R.isEmpty), R.filter(this.checkIfContractsExists(templateSelected, templateGroupSelected))), partners);
    return R.call(R.cond([
      [R.equals(0), R.always(<SelectTemplates updateProps={this.props.updateProps} />)],
      [R.equals(1), R.always(
        <div>
          <SendToPartners
            validityCheckFn={processPartnersForSendingRates(
              templateSelected,
              templateGroupSelected,
              )}
            startDate={startDate}
            endDate={endDate}
          />
          {
            // contractExistsPartnerExist ?
            //   <div style={{ color: '#c07942', display: 'flex', justifyContent: 'space-between', fontSize: '12px', lineHeight: '12px', marginTop: '12px' }}>
            //     <span>* Contract exists: </span>
            //     <span style={{ width: '87%', whiteSpace: 'pre' }}>
            //       {`Please note that you have an existing contract for this partner and contracting period.
            //     \nBy proceeding with this wizard, we will create a new contract for this partner and the existing contract will not be replaced.
            //     \nIf you would like to send an update to this partner, please do so in the templates.`}
            //     </span>
            //   </div>
            //   : ''
          }
        </div>
      )],
      [R.equals(2), R.always(<AddAlloments templateSelected={templateSelected} templateGroupSelected={templateGroupSelected} showAllocationError={showAllocationError}/>)],
      [R.T, R.always(
        <ReviewSend
          updateProps={this.props.updateProps}
          partners={validPartners}
          sentPartnersLength={validPartners.length}
          sendingContracts={sendingContracts}
          goBack={() => this.props.router.goBack()}
          templateSelected={templateSelected}
          message={message}
          subject={subject}
          bccSelf={bccSelf}
          assignTag={assignTag}
          assignFolder={assignFolder}
          contractsSent={contractsSent}
          showAllPartners={showAllPartners}
          templateGroupSelected={templateGroupSelected}
        />
      )],
    ]), stepIndex);
  };

  handleNext = () => {
    this.props.updateProps({
      stepIndex: this.props.stepIndex + 1,
    });
  };

  handlePrev = () => {
    const { stepIndex, updateProps } = this.props;
    updateProps({ stepIndex: stepIndex - 1 });
  };

  handleActionButton = validPartners => () => {
    const {
      stepIndex,
      updateProps,
      templateSelected,
      templateGroupSelected,
      sendContracts,
      message,
      subject,
      bccSelf,
      partners,
      contractingPartners,
      billingPlan,
      newPartnersSelected,
      folders,
      tags,
    } = this.props;
    return R.call(R.cond([
      [R.equals(0), () => {
        if (isNilOrEmpty(templateSelected) && isNilOrEmpty(templateGroupSelected)) {
          updateProps({ error: 'Please select a template before proceeding.' });
          debounce(() => updateProps({ error: '' }), 7000)();
        } else this.handleNext();
      }],
      [R.equals(1), () => {
        const contractingPartnersLength = (contractingPartners || []).filter(obj => obj.paidBy === 'Supplier').length;
        if (!validPartners.length) {
          updateProps({ error: 'Please select at least ONE valid partner before proceeding.' });
          debounce(() => updateProps({ error: '' }), 7000)();
        } else if (billingPlan === 'basic' && newPartnersSelected.length + contractingPartnersLength > Math.max(basicNo, contractingPartnersLength)) {
          updateProps({ error: `You've selected ${newPartnersSelected.length} new ${pluralize('partner', newPartnersSelected.length)}.
          If you would like to continue, please remove ${newPartnersSelected.length - Math.max(basicNo, contractingPartnersLength) + contractingPartnersLength} from your new contracting partners.` });
          debounce(() => updateProps({ error: '' }), 7000)();
        } else this.handleNext();
      }],
      [R.equals(2), () => {
        const allocationValid = partners.every(partner => isNilOrEmpty(partner.templates)
        || partner.templates.every(obj => obj.products.every(prod => {
          return isNilOrEmpty(prod.customizedAllocation) || prod.customizedAllocation.every(allo => {
            if (allo.allocationType === 'onRequest') return true;
            if (allo.allocationType === 'freesale') return Boolean(allo.releaseBackDays);
            return allo.allotments.every(allotment => Boolean(allotment.releaseBackDays) && Boolean(allotment.numberOfRooms));
          });
        })));
        if (!allocationValid) {
          updateProps({ showAllocationError: true, error: 'Please fill all required fields.' });
          debounce(() => updateProps({ error: '' }), 4000)();
        }
        else this.handleNext();
      }],
      [R.equals(3), () => {
        if (!subject) {
          updateProps({ error: 'Please enter a subject line.' });
          debounce(() => updateProps({ error: '' }), 7000)();
        } else {
          sendContracts({ templateSelected, templateGroupSelected, message, partners: validPartners, subject, bccSelf, folders, tags });
        }
      }],
      [R.T, () => updateProps({ error: 'Please refresh your page and try again.' })],
    ]), stepIndex);
  };
  invalidCheck = R.curry((templateSelected, templateGroupSelected, partner) => {
    const partnerErr = processPartnersForSendingRates(templateSelected, templateGroupSelected, partner);
    // return partnerErr && partnerErr !== '* Contract exists';
    return partnerErr;
  });
  checkIfContractsExists = R.curry((templateSelected, templateGroupSelected, partner) => {
    const partnerErr = processPartnersForSendingRates(templateSelected, templateGroupSelected, partner);
    return partnerErr === '* Contract exists';
  });
  render() {
    const { stepIndex, error, contractsSent, templateSelected, templateGroupSelected, partners, sendingContracts } = this.props;
    const contentStyle = { margin: '0 16px', padding: '16px', overflow: 'hidden' };
    const inValidPartnersLength = R.call(R.compose(
      R.length,
      R.filter(this.invalidCheck(templateSelected, templateGroupSelected))
    ), partners);
    const validPartners = R.reject(this.invalidCheck(templateSelected, templateGroupSelected), partners);
    const validPartnersLength = R.length(validPartners);

    const numberOfTemplateSelected = (() => {
      if (!isNilOrEmpty(templateGroupSelected)) return templateGroupSelected.templates.length;
      if (!isNilOrEmpty(templateSelected)) return 1;
      return 0;
    })();
    return (
      <Paper style={{ width: '100%', maxWidth: '900px', margin: 'auto' }}>
        <div style={{ backgroundColor: '#00BCD4', height: '51px', paddingLeft: '16px', lineHeight: '51px', color: 'white', fontSize: '20px' }} >Send Contracts with Allocation</div>
        <Stepper activeStep={stepIndex}>
          <Step>
            <StepLabel style={{ height: '54px' }}>
              {
                numberOfTemplateSelected === 0 || stepIndex === 0
                  ? 'Select Templates'
                  : `${numberOfTemplateSelected} ${pluralize('Templates', numberOfTemplateSelected)} Selected`
              }
            </StepLabel>
          </Step>
          <Step>
            <StepLabel style={{ height: '54px' }}>
              {
                stepIndex === 2 || stepIndex === 3
                  ? `${validPartnersLength} ${pluralize('Partners', validPartnersLength)} Selected`
                  : 'Select Partners'
              }
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>Add Allotments</StepLabel>
          </Step>
          <Step>
            <StepLabel>Review & Send</StepLabel>
          </Step>
        </Stepper>
        <div style={contentStyle}>
          <div>{this.getStepContent(validPartners)}</div>
          {
            contractsSent ? (
              <div/>
            ) : (
              <div style={{ marginTop: 24, marginBottom: 12, display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
                <RaisedButton
                  label={stepIndex === 3 ? 'Send' : 'Next'}
                  secondary
                  loader={sendingContracts}
                  onTouchTap={this.handleActionButton(validPartners)}
                />
                <FlatButton
                  label="Back"
                  disabled={stepIndex === 0}
                  onTouchTap={this.handlePrev}
                  style={{ marginRight: 12 }}
                />
                <div style={{ width: '60%', color: error ? 'red' : 'rgba(0, 0, 0, 0.54)' }}>
                  {error}
                  {
                    !error && !R.isEmpty(partners) && stepIndex === 1 ?
                      `${validPartnersLength} valid partner${validPartnersLength === 1 ? '' : 's'}, ${inValidPartnersLength} invalid partner${inValidPartnersLength === 1 ? '' : 's'}`
                      : ''
                  }
                </div>
              </div>
            )
          }
        </div>
      </Paper>
    );
  }
}
SendContractStepper.propTypes = propTypes;

const mapStateToProps = ({ contracting, user }) => ({
  companyType: user.getIn(['user', 'type']),
  partners: contracting.sendToPartners.get('partnersToSendTo').toJS(),
  billingPlan: user.get('billingPlan'),
  contractingPartners: contracting.sendToPartners.get('contractingPartners').toJS(),
  newPartnersSelected: contracting.sendToPartners.get('newPartnersSelected').toJS(),
  locationId: contracting.supplierWizard.getIn(['templateSelected', 'locationId']),
  ...contracting.supplierWizard.toJS(),
});

export default connect(mapStateToProps)(SendContractStepper);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/supplier-initiated/container-allotments.jsx